<template>
    <div class="experts-container">
        <achiTitle title="专家人才库" subtitle="汇聚各领域顶尖人才 助力科技创新发展"></achiTitle>

        <!-- 搜索框 -->
        <div class="search-box">
            <el-input v-model="searchQuery" placeholder="搜索专家姓名或研究领域..." prefix-icon="search" clearable
                @input="handleSearch" class="search-input"></el-input>
        </div>

        <!-- 加载状态 -->
        <el-loading v-if="loading" fullscreen text="正在加载专家信息..."></el-loading>

        <!-- 错误提示 -->
        <el-alert v-if="error" title="数据加载失败" :description="error" type="error" show-icon
            class="error-alert"></el-alert>

        <!-- 专家卡片列表 -->
        <div class="experts-cards" v-if="!loading && !error">
            <!-- 无数据提示 -->
            <div v-if="filteredExperts.length === 0" class="no-results">
                <el-empty description="没有找到匹配的专家"></el-empty>
            </div>

            <!-- 卡片网格 -->
            <el-row :gutter="30" v-else>
                <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="expert in currentPageExperts" :key="expert.id">
                    <!-- 引用ExpertItem组件 -->
                    <expert-item :expert="expert" :intro-max-length="80" />
                </el-col>
            </el-row>

            <!-- 分页组件 -->
            <div class="pagination-container" v-if="filteredExperts.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[4, 8, 12, 16]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="filteredExperts.length"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import achiTitle from '../components/achievement/achi_title.vue';
import ExpertItem from './expertItem.vue';

export default {
    data() {
        return {
            searchQuery: '',
            experts: [],
            loading: true,
            error: null,
            currentPage: 1,    // 当前页码
            pageSize: 8        // 每页显示数量
        };
    },
    computed: {
        // 根据搜索词筛选专家
        filteredExperts() {
            if (!this.searchQuery) {
                return this.experts;
            }

            const query = this.searchQuery.toLowerCase();
            return this.experts.filter(expert => {
                // 搜索专家姓名
                const nameMatch = expert.name.toLowerCase().includes(query);
                // 搜索研究领域
                const fieldMatch = expert.fields && expert.fields.some(
                    field => field.toLowerCase().includes(query)
                );
                return nameMatch || fieldMatch;
            });
        },
        // 计算当前页显示的专家
        currentPageExperts() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.filteredExperts.slice(startIndex, endIndex);
        }
    },
    mounted() {
        // 组件挂载时加载数据
        this.loadData();
    },
    components: {
        achiTitle,
        ExpertItem
    },
    methods: {
        // 从JSON文件加载数据
        async loadData() {
            try {
                this.loading = true;
                // 读取专家JSON文件
                const response = await this.$httpTemp.get('/mock/technical_experts.json');
                this.experts = response // 修复之前可能的bug，添加.data
                console.log('加载专家数据成功:', this.experts);
                this.error = null;
            } catch (err) {
                this.error = '数据加载失败，请稍后重试';
                console.error('加载专家数据出错:', err);
            } finally {
                this.loading = false;
            }
        },

        // 搜索处理
        handleSearch() {
            // 搜索时重置到第一页
            this.currentPage = 1;
        },
        // 处理每页显示数量变化
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;  // 重置到第一页
        },
        // 处理页码变化
        handleCurrentChange(val) {
            this.currentPage = val;
            // 滚动到页面顶部
            window.scrollTo(0, 0);
        }
    }
};
</script>

<style scoped>
.experts-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 30px;
}

.search-box {
    margin-bottom: 45px;
    max-width: 750px;
}

.search-input {
    width: 100%;
    font-size: 18px;
}

.error-alert {
    margin-bottom: 30px;
    font-size: 16px;
}

.experts-cards {
    margin-top: 30px;
}

.no-results {
    text-align: center;
    padding: 50px 0;
}

/* 分页样式 */
.pagination-container {
    margin-top: 40px;
    text-align: center;
}
</style>
